import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import { useInstantSearch } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import MenuButtonLabel from './components/MenuButtonLabel';
import SearchCount from './components/SearchCount';
import ProductSearchCount from './components/ProductSearchCount';
const countForIndex = (scopedResults, indexName) => {
  const match = scopedResults?.find(entry => entry.indexId === indexName || entry.indexName === indexName);
  const count = match?.results?.nbHits;
  return Number.isFinite(count) ? count : 0;
};
const MobileSearchIndexSelector = () => {
  const $ = _c(50);
  const [expandableOpen, setExpandableOpen] = useState(false);
  const {
    currentSearchSection,
    updateSearchSection
  } = useAdvancedSearchContext();
  const {
    results,
    scopedResults
  } = useInstantSearch();
  const getSectionTitle = _temp;
  const searchTitle = getSectionTitle(currentSearchSection);
  let t0;
  if ($[0] !== updateSearchSection) {
    t0 = indexName => {
      updateSearchSection(indexName);
      setExpandableOpen(false);
    };
    $[0] = updateSearchSection;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleIndexClick = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("md:hidden mobile-filters", {
      "mobile-filters--showTopBorder": true
    });
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] !== expandableOpen) {
    t2 = () => {
      setExpandableOpen(!expandableOpen);
    };
    t3 = classNames("flex-1 min-h-[3rem] space-x-1 flex items-center justify-center text-sm font-bold", {
      "mobile-filters__menu-expandable-button--open": expandableOpen
    });
    $[3] = expandableOpen;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== searchTitle) {
    t4 = <MenuButtonLabel title={searchTitle} />;
    $[6] = searchTitle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-center divide-x divide-gray-light7"><button type="button" onClick={t2} className={t3} aria-label="Toggle filters">{t4}</button></div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = !expandableOpen;
  let t7;
  if ($[12] !== expandableOpen || $[13] !== t6) {
    t7 = classNames("mobile-filters__expandable relative -top-px", {
      "mobile-filters__expandable--open border-b border-gray-light6": expandableOpen,
      hidden: t6
    });
    $[12] = expandableOpen;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== results) {
    t8 = Number.isFinite(results?.nbHits) ? results.nbHits : 0;
    $[15] = results;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== currentSearchSection || $[18] !== handleIndexClick || $[19] !== t8) {
    t9 = <ProductSearchCount title="Products" id={ALGOLIA_INDEX_NAME.PRODUCTS} selectedOption={currentSearchSection} indexClick={handleIndexClick} countOverride={t8} />;
    $[17] = currentSearchSection;
    $[18] = handleIndexClick;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== scopedResults) {
    t10 = countForIndex(scopedResults, ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS);
    $[21] = scopedResults;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== currentSearchSection || $[24] !== handleIndexClick || $[25] !== t10) {
    t11 = <SearchCount title="Customer Photos" id={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS} selectedOption={currentSearchSection} indexClick={handleIndexClick} countOverride={t10} />;
    $[23] = currentSearchSection;
    $[24] = handleIndexClick;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== scopedResults) {
    t12 = countForIndex(scopedResults, ALGOLIA_INDEX_NAME.REVIEWS);
    $[27] = scopedResults;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== currentSearchSection || $[30] !== handleIndexClick || $[31] !== t12) {
    t13 = <SearchCount title="Reviews" id={ALGOLIA_INDEX_NAME.REVIEWS} selectedOption={currentSearchSection} indexClick={handleIndexClick} countOverride={t12} />;
    $[29] = currentSearchSection;
    $[30] = handleIndexClick;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== scopedResults) {
    t14 = countForIndex(scopedResults, ALGOLIA_INDEX_NAME.STATIC_PAGES);
    $[33] = scopedResults;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== currentSearchSection || $[36] !== handleIndexClick || $[37] !== t14) {
    t15 = <SearchCount title="Pages" id={ALGOLIA_INDEX_NAME.STATIC_PAGES} selectedOption={currentSearchSection} indexClick={handleIndexClick} countOverride={t14} />;
    $[35] = currentSearchSection;
    $[36] = handleIndexClick;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t11 || $[40] !== t13 || $[41] !== t15 || $[42] !== t9) {
    t16 = <div className="text-base text-gray font-normal">{t9}{t11}{t13}{t15}</div>;
    $[39] = t11;
    $[40] = t13;
    $[41] = t15;
    $[42] = t9;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t16 || $[45] !== t7) {
    t17 = <div className={t7}>{t16}</div>;
    $[44] = t16;
    $[45] = t7;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t17 || $[48] !== t5) {
    t18 = <div className={t1}>{t5}{t17}</div>;
    $[47] = t17;
    $[48] = t5;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  return t18;
};
export default MobileSearchIndexSelector;
function _temp(section) {
  switch (section) {
    case ALGOLIA_INDEX_NAME.PRODUCTS:
      {
        return "Products";
      }
    case ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS:
      {
        return "Customer Photos";
      }
    case ALGOLIA_INDEX_NAME.REVIEWS:
      {
        return "Reviews";
      }
    case ALGOLIA_INDEX_NAME.STATIC_PAGES:
      {
        return "Pages";
      }
    default:
      {
        return "Products";
      }
  }
}